<template>
  <v-container fluid>
    <Navbar />
    <TagsLista
      titulo="Tags"
    />
  </v-container>
</template>

<script>
import TagsLista from '../components/tag/TagsLista';

export default {
  name: 'TagsView',
  components: {
    TagsLista
  },
  destroyed() {
    this.$store.dispatch('resetTagsState');
  }
}
</script>